var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0852 7.32916L1.58524 0.579157C1.31498 0.442926 0.987586 0.483942 0.758338 0.683161C0.52909 0.88238 0.442664 1.19952 0.538611 1.48736L2.45952 7.25006H7.99979C8.41434 7.25006 8.74979 7.58551 8.74979 8.00006C8.74979 8.41461 8.41434 8.75006 7.99979 8.75006H2.45952L0.538611 14.5128C0.442664 14.8006 0.52909 15.1177 0.758338 15.317C0.897498 15.4378 1.07328 15.5001 1.24979 15.5001C1.36405 15.5001 1.47904 15.4737 1.58524 15.421L15.0852 8.67096C15.3394 8.54351 15.4998 8.28424 15.4998 8.00006C15.4998 7.71588 15.3394 7.4566 15.0852 7.32916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendVector);
export default __webpack_public_path__ + "static/media/send-vector.81fe7bc53b30e820a9d43a1046a834a1.svg";
export { ForwardRef as ReactComponent };